import header from '../layouts/header';
import clientIcons from '../layouts/client-icons';
import newsSlider from '../layouts/news-slider';
import teamSlider from '../layouts/team-block';
import projectSlider from '../layouts/project-slider';
import leftRightSlider from '../layouts/left-right-slider';
import singleProjectSlider from '../layouts/single-project-slider';
import location from '../layouts/location';
import scrollingBorder from '../layouts/scrolling-border';
import AOS from 'aos'
import map from '../layouts/map';

export default {
  init() {
    // JavaScript to be fired on all pages
    header.init()
    this.aos()
  },
  aos() {
    // AOS.init({
    //   once: false,
    //   offset: 10,
    // })
    let scrollRef = 0;
    window.addEventListener('scroll', function () {
      // increase value up to 10, then refresh AOS
      scrollRef <= 1 ? scrollRef++ : AOS.init({
        once: false,
        offset: 10,
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    clientIcons()
    newsSlider()
    teamSlider()
    projectSlider()
    leftRightSlider()
    singleProjectSlider()
    location()
    map.initMap()
    scrollingBorder()
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js